module.exports = __webpack_public_path__ + "static/media/01.c4daa1d9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/01.gif
// module id = 55
// module chunks = 0